import React from "react";
import {
  DisplayMedia
} from "../../_metronic/_partials";

export function DMedia(props) {
  return <DisplayMedia {...props} />;
}
